import { useEffect, useRef } from 'react';

export default function usePrevious<Val extends unknown>(value: Val) {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
